import React from 'react';
import toast from 'react-hot-toast';
import { generateDownloadFilename } from '../../../../utils/fileUtils';

const FaceSwapRightPanel = ({
  t,
  mainTab,
  generatedImageText,
  generatedImageImage,
  shareUrlText,
  shareUrlImage,
  image,
  onUploadAreaClick,
  onImageChange,
  setShareModal,
  setPreviewImageUrl,
  setShowPreviewModal
}) => {
  const handleDownload = (imageData) => {
    const downloadUrl = imageData.url;
    fetch(downloadUrl)
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const filename = generateDownloadFilename(imageData.id);
        link.download = `${filename}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        console.error('Download image failed:', error);
        toast.error(t('aiWorkbench.faceSwap.messages.downloadFailed'));
      });
  };

  return (
    <div className="right-panel">
      {mainTab === 'image-to-image' ? (
        <div className="image-to-image-panel">
          {generatedImageImage && generatedImageImage.url && (
            <div className="result-section">
              <h4 className="section-title">{t('aiWorkbench.faceSwap.result.title')}</h4>
              <div className="result-container" style={{ position: 'relative' }}>
                <img src={generatedImageImage.url} alt="generated" className="image-preview" />
                <button
                  onClick={() => {
                    if (!shareUrlImage) return;
                    setShareModal({ open: true, mediaUrl: shareUrlImage, mediaType: 'image' });
                  }}
                  disabled={!shareUrlImage}
                  style={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    width: 32,
                    height: 32,
                    borderRadius: 8,
                    border: '1px solid #444',
                    background: '#2a2a2a',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: shareUrlImage ? 'pointer' : 'not-allowed',
                    opacity: shareUrlImage ? 1 : 0.6
                  }}
                  aria-label={t('creationRecord.share')}
                >
                  <img
                    src="/icons/share.svg"
                    alt={t('creationRecord.share')}
                    style={{ width: 16, height: 16, filter: 'brightness(0) invert(1)', padding: 0 }}
                  />
                </button>
              </div>
              <div className="section-actions">
                <button
                  className="preview-btn"
                  onClick={() => {
                    setPreviewImageUrl(generatedImageImage);
                    setShowPreviewModal(true);
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                  {t('aiWorkbench.faceSwap.buttons.preview')}
                </button>
                <button
                  className="download-btn"
                  onClick={() => {
                    if (!generatedImageImage || !generatedImageImage.url) return;
                    handleDownload(generatedImageImage);
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7,10 12,15 17,10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                  </svg>
                  {t('aiWorkbench.faceSwap.buttons.download')}
                </button>
              </div>
            </div>
          )}

          <div className="upload-section">
            <h4 className="section-title">{t('aiWorkbench.faceSwap.upload.title')}</h4>
            <div className="upload-container" onClick={onUploadAreaClick}>
              {image ? (
                <img src={image} alt="preview" className="image-preview" />
              ) : (
                <div className="upload-placeholder">
                  <span className="upload-icon">🖼️</span>
                  <p>{t('aiWorkbench.faceSwap.upload.placeholder')}</p>
                </div>
              )}
            </div>
            <input type="file" id="file-upload" style={{ display: 'none' }} onChange={onImageChange} />
          </div>
        </div>
      ) : (
        <div className="text-to-image-panel">
          <div className="result-section">
            <h4 className="section-title">{t('aiWorkbench.faceSwap.result.title')}</h4>
            <div className="result-container" style={{ position: 'relative' }}>
              {generatedImageText && generatedImageText.url ? (
                <>
                  <img src={generatedImageText.url} alt="generated" className="image-preview" />
                  <button
                    onClick={() => {
                      if (!shareUrlText) return;
                      setShareModal({ open: true, mediaUrl: shareUrlText, mediaType: 'image' });
                    }}
                    disabled={!shareUrlText}
                    style={{
                      position: 'absolute',
                      top: 8,
                      right: 8,
                      width: 32,
                      height: 32,
                      borderRadius: 8,
                      border: '1px solid #444',
                      background: '#2a2a2a',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: shareUrlText ? 'pointer' : 'not-allowed',
                      opacity: shareUrlText ? 1 : 0.6
                    }}
                    aria-label={t('creationRecord.share')}
                  >
                    <img
                      src="/icons/share.svg"
                      alt={t('creationRecord.share')}
                      style={{ width: 16, height: 16, filter: 'brightness(0) invert(1)', padding: 0 }}
                    />
                  </button>
                </>
              ) : (
                <div className="result-placeholder">
                  <p>{t('aiWorkbench.faceSwap.result.placeholder')}</p>
                </div>
              )}
            </div>
            {generatedImageText && generatedImageText.url && (
              <div className="section-actions">
                <button
                  className="preview-btn"
                  onClick={() => {
                    setPreviewImageUrl(generatedImageText);
                    setShowPreviewModal(true);
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                  {t('aiWorkbench.faceSwap.buttons.preview')}
                </button>
                <button
                  className="download-btn"
                  onClick={() => {
                    if (!generatedImageText || !generatedImageText.url) return;
                    handleDownload(generatedImageText);
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7,10 12,15 17,10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                  </svg>
                  {t('aiWorkbench.faceSwap.buttons.download')}
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default FaceSwapRightPanel;

